// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3jGqE","containerItemsCenter":"Skeleton_containerItemsCenter__2A-IW"};